module.exports = __webpack_public_path__ + "static/banner-5739f074da76f3fe3cf8744118515287.jpg";